export const account = {
  dashboard: {
    editEmailAddress: "Modifier l’adresse de courriel",
    editAdress: "Modifier les données client",
    changePassword: "Modifier le mot de passe",
  },
  backToDashboard: "Retour",
  accountView: {
    customerData: "Données client",
    customer: "Client",
  },
  editEmailAddressForm: {
    header: "Quelle est votre adresse de courriel actuelle?",
    backToStart: "Retour à la page d’accueil",
    labels: {
      email: "Courriel",
      submit: "Modifier l’adresse de courriel",
    },
    messages: {
      confirmationSent:
        "Nous vous avons envoyé un courriel pour confirmer votre nouvelle adresse. Veuillez vérifier votre boîte aux lettres électronique.",
      anErrorHasOccured:
        "Une erreur semble s’être produite ici. Merci de vérifier vos courriels ou de réessayer ultérieurement.",
      emailChangedSuccessful: "Ihre E-Mail Adresse wurde erfolgreich geändert.",
      confirmationLinkInvalid:
        "Votre adresse courriel n'a pas pu être modifiée. Le lien de confirmation n’est pas valide ou est arrivé à expiration. Veuillez réessayer.",
    },
  },
  changePasswordForm: {
    header: "Modifier le mot de passe",
    chooseNewPassword: "Veuillez définir votre nouveau mot de passe.",
    labels: {
      submit: "Modifier le mot de passe",
    },
    messages: {
      passwordChangePending: "En cours de modification…",
      passwordChangedSuccessful: "Votre mot de passe a été modifié.",
    },
    hints: {
      atLeastNCharacters:
        "Pas de longueur minimale. | Au moins un caractère. | Au moins {n} caractères.",
      passwordsDontMatch: "Les mots de passe ne correspondent pas.",
    },
  },
  resetPasswordForm: {
    header: "Réinitialisez votre mot de passe",
    chooseNewPassword: "Veuillez définir votre nouveau mot de passe",
    labels: {
      newPassword: "Nouveau mot de passe",
      repeatPassword: "Répéter le mot de passe",
      submit: "Réinitialiser le mot de passe",
      password: "Mot de passe",
    },
    messages: {
      resetEmailSent:
        "Si un compte existe pour cette adresse de courriel, vous avez reçu un lien pour réinitialiser votre mot de passe.",
      passwordResetPending: "En cours de modification…",
      passwordResetSuccessful: "Votre mot de passe a été modifié",
      passwordResetBlocked:
        "Vous avez déjà reçu un lien pour réinitialiser votre mot de passe. Vous ne pouvez demander un nouveau lien que toutes les 24 heures.",
      genericError:
        "Une erreur s’est produite ici. Il se peut que le nom d’utilisateur utilisé ne soit pas correct. Veuillez corriger les éventuelles fautes de frappe ou réessayer plus tard.",
      resetLinkInvalid:
        "Une erreur semble s’être produite ici. Le lien pour réinitialiser votre mot de passe a déjà été utilisé ou est arrivé à expiration.",
    },
    hints: {
      atLeastNCharacters:
        "Pas de longueur minimale. | Au moins un caractère. | Au moins {n} caractères.",
      passwordsDontMatch: "Les mots de passe ne concordent pas.",
    },
  },
};
